import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgPinterest = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                d: "M11.989 1C5.91975 1 1 5.91975 1 11.9881C1 16.6438 3.89483 20.6203 7.98317 22.2199C7.88692 21.35 7.80075 20.0172 8.02075 19.0675C8.2215 18.2086 9.30958 13.6069 9.30958 13.6069C9.30958 13.6069 8.9805 12.9469 8.9805 11.9743C8.9805 10.4499 9.86692 9.30592 10.9678 9.30592C11.9065 9.30592 12.3593 10.0108 12.3593 10.8532C12.3593 11.7965 11.7607 13.2063 11.45 14.5126C11.1887 15.6062 12 16.4972 13.0771 16.4972C15.0277 16.4972 16.5311 14.4393 16.5311 11.4674C16.5311 8.84483 14.64 7.00417 11.9404 7.00417C8.81458 7.00417 6.98217 9.35267 6.98217 11.7699C6.98217 12.7168 7.34333 13.7343 7.79708 14.2825C7.88783 14.3925 7.89975 14.4888 7.875 14.5988C7.7925 14.9425 7.60642 15.6978 7.56883 15.8482C7.52025 16.0544 7.41117 16.0966 7.20125 15.9994C5.83083 15.3669 4.971 13.3613 4.971 11.7406C4.971 8.27925 7.49 5.09292 12.231 5.09292C16.0425 5.09292 19.007 7.81267 19.007 11.439C19.007 15.2294 16.6172 18.2792 13.2934 18.2792C12.1806 18.2792 11.1356 17.7026 10.7652 17.0151L10.0787 19.6258C9.83208 20.5837 9.15833 21.7818 8.7055 22.5096C9.73492 22.8258 10.8193 23 11.9597 23C18.0161 23 22.9459 18.0821 22.9459 12.0119C22.9459 5.94083 18.0161 1.02383 11.9597 1.02383L11.989 1Z",
                fill: "currentColor"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgPinterest);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const Pinterest = Memo;
export { Pinterest as default };
